<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :mask-closable="false"
      title="编辑CPE型号"
      :ok-button-props="{ props: { loading: submitting } }"
      @ok="handleSubmit"
    >
      <a-form
        class="simiot-compact-form"
        :form="form"
        :label-col="{ span: 7 }"
        :wrapper-col="{ span: 15 }"
        @submit="handleSubmit"
      >
        <a-form-item label="采购型号">
          <a-input
            v-decorator="['purchase_model', {
              normalize: this.$lodash.trim,
              rules: [
                { required: true, message: '请输入采购型号' },
                { max: 100, message: '最多100个字符' },
              ]
            }]"
            placeholder="供应商采购型号"
          />
        </a-form-item>

        <a-form-item label="对外展示型号">
          <a-input
            v-decorator="['display_model', {
              normalize: this.$lodash.trim,
              rules: [
                { max: 100, message: '最多100个字符' },
              ]
            }]"
            placeholder="为空则等于采购型号"
          />
        </a-form-item>

        <a-form-item label="备注">
          <a-textarea
            v-decorator="['remark', {
              rules: [
                { max: 500, message: '最多500个字符' },
              ]
            }]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { findCpeSupplierModelForm, updateCpeSupplierModel } from '@/api/cpe_supplier_model'

export default {
  name: 'EditCpeSupplierModel',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'cpe_supplier_model_edit' }),
      submitting: false,
      cpeSupplierId: 0
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchFormData()
  },
  methods: {
    fetchFormData() {
      findCpeSupplierModelForm(this.id).then((res) => {
        if (res.code === 0) {
          this.cpeSupplierId = res.data.cpe_supplier_id
          this.form.setFieldsValue({
            purchase_model: res.data.purchase_model,
            display_model: res.data.display_model,
            remark: res.data.remark
          })
        }
      })
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }

      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          updateCpeSupplierModel(this.id, Object.assign({}, values, {
            cpe_supplier_id: this.cpeSupplierId
          })).then((res) => {
            if (res.code === 0) {
              this.isShow = false
              this.$emit('completed')
            }
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>
